// extracted by mini-css-extract-plugin
module.exports = {"icon":"iD7Mi6Xe3ExtMcgtYKqFr"};